import type * as types from './types';

import { type Dimensions, type SingleDimension } from '../../types/dimensions';
import { type QuantitativeSize } from '../../types/sizes';
import { quantitativeSizeToString } from '../../util/sizes';

export const validateAspectRatio = (aspectRatio: Dimensions<number>) => {
  if (aspectRatio.width <= 0 || aspectRatio.height <= 0) {
    throw new TypeError("The 'aspectRatio' must be > 0!");
  }
};

export const getImageSize = <S extends Dimensions | QuantitativeSize | SingleDimension>(
  size: S,
): types.ImageSize<S> => {
  if (typeof size === 'number' || typeof size === 'string') {
    return {
      height: quantitativeSizeToString(size, 'px'),
      width: quantitativeSizeToString(size, 'px'),
    } as types.ImageSize<S>;
  }
  if (size.height !== undefined) {
    return {
      height: quantitativeSizeToString(size.height, 'px'),
      width: size.width === undefined ? 'auto' : quantitativeSizeToString(size.width, 'px'),
    } as types.ImageSize<S>;
  }
  return {
    height: 'auto',
    width: quantitativeSizeToString(size.width, 'px'),
  } as types.ImageSize<S>;
};
